export function isPowerActSigned(power) {
  if (power.signatureFlowVersion || power.signatureParticipants?.length) return Boolean(power.signatureCompletedAt && power.signatureEnvelopeStatus === 'completed' && power.signatureParticipants?.length && power.signatureParticipants.every(person => person.status === 'completed'));
  return Boolean(power.clientSignature?.signed && power.adminSignature?.signed);
}
